/*
通过mutation间接更新state的多个方法的对象
 */
import user from '@/store/actions/user/user.js'
import site from '@/store/actions/site/site.js'
import menu from '@/store/actions/menu/menu.js'
import nav from '@/store/actions/nav/nav.js'

import design from '@/store/actions/design/design.js'
export default {
  ...user,
  ...site,
  ...menu,
  ...nav,

  ...design
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js